module.exports = __webpack_public_path__ + "static/media/Chapter12.e7057d74.pdf";